import { Collapse, Row } from "antd";
import React, { useState } from "react";
import './invoice-right-modal.scss'
import CloseIcon from '../../../assets/images/write-to-us-close.svg'
import WriteToUs from "./write-to-us";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../store/store";
const InvoiceRightModal = ({ OrderId, isOpen, setIsOpen }) => {
const {user} = useStore();
  const {t} = useTranslation();
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [openWriteToUsModal, setOpenWriteToUsModal] = useState(false);
  const handleOutsideClick = (e) => {
    if (e.target.id === "invoice-modal-wrapper") {
      setIsOpen(false);

    }
  };
  // const redirectToSupportEmail = () => {
  //   const userName = user?.userName ;
  //   const userCountry = user?.operatingCountry;
  //   const email = "contact@trukker.com";
  //   const subject = `Need Help | ${userName} | ${userCountry}`;
  
  //   const gmailLink = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(subject)}`;
  //   window.open(gmailLink, "_blank");
  // };
  const handleRaiseTicket = (label) => {

    setSelectedTicket(label);
    setOpenWriteToUsModal(true);
  
  };
  const text = (
    <p
      style={{
        fontWeight:'400',
        color:'var(--text-muted, #757575)',
        lineHeight:'120%',
          color:'var(--text-muted, #757575)'
      }}
    >
     
    </p>
  );
  const textPriceRelatedConcern = (
    <p
      style={{
       fontWeight:'400',
        color:'var(--text-muted, #757575)',
        lineHeight:'120%'
      }}
    >
      {t("NEED_HELP_PRICE_RELATED_MSG")}
    </p>
  );
  const textIncorrectOrderDetails = (
    <p
      style={{
        fontWeight:'400',
        color:'var(--text-muted, #757575)',
        lineHeight:'120%',
          color:'var(--text-muted, #757575)'
      }}
    >
     {t("NEED_HELP_ORDER_DETAIL_MSG")}
    </p>
  );
  const Invoiceitems = [
    {
      key: '2',
      label: t("NEED_HELP_INVOICE_PRICE_CONCERN"),
      children: (
        <p>
          {textPriceRelatedConcern}
          <span
            style={{ color: 'var(--brand-primary, #FF833C)', cursor: 'pointer', display: 'flex', fontWeight: '600', fontSize: '14px' }}
            onClick={() => handleRaiseTicket(t("NEED_HELP_INVOICE_PRICE_CONCERN"))}
          >
            <span>{t("NEED_HELP_CONTACT_US")}</span>
          </span>
        </p>
      ),
    },
    {
      key: '3',
      label: t("NEED_HELP_INCORRECT_ORDER_DETAILS"),
      children: (
        <p>
          {textIncorrectOrderDetails}
          <span
            style={{ color: 'var(--brand-primary, #FF833C)', cursor: 'pointer', display: 'flex', fontWeight: '600', fontSize: '14px' }}
            onClick={() => handleRaiseTicket(t("NEED_HELP_INCORRECT_ORDER_DETAILS"))}
          >
            <span>{t("NEED_HELP_CONTACT_US")}</span>
          </span>
        </p>
      ),
    },
    {
      key: '4',
      label: t("NEED_HELP_FAQS_OTHERS"),
      children: (
        <p>
          {text}
          <span
            style={{ color: 'var(--brand-primary, #FF833C)', cursor: 'pointer', display: 'flex', fontWeight: '600', fontSize: '14px' }}
            onClick={() => handleRaiseTicket(t("NEED_HELP_FAQS_OTHERS"))}
          >
            <span>{t("NEED_HELP_CONTACT_US")}</span>
          </span>
        </p>
      ),
    },
  ];
  
  return (
    <>
      {isOpen && (
        <div
          id="invoice-modal-wrapper"
          className="invoice-modal-wrapper"
          onClick={handleOutsideClick}
        >
          <div className={`modal ${isOpen ? "open" : ""}`}>
            <div className="modal-content">
              <Row className="first-row">
                <span className="invoiceId-title">{t("NEED_HELP_ORDER_ID")}: {" " + OrderId}</span>
                <span className="crossicon"><img src={CloseIcon} onClick={() => setIsOpen(false)} /></span>
              </Row>
              <div className="collapse-wrapper">

                <Collapse items={Invoiceitems} bordered={false} defaultActiveKey={['']} />
              </div>
            </div>
          </div>
        </div>
      )}
      {openWriteToUsModal && <WriteToUs setOpenWriteToUsModel={setOpenWriteToUsModal} modalTitle={OrderId} modalDescription={selectedTicket}/>}
    </>
  );
};

export default InvoiceRightModal;
